export const personalInfo = {
  getStarted: `Get Started`,
  startContactInfo: `Please start by confirming your contact information.`,
  confirmContactInfo: `Please provide your contact information below should we need to contact you about this investment.`,
  contactInformation: `Contact Information`,
}
